import React from 'react'
import styled from 'styled-components';
import { THEME } from '../../genericComponents/globalStyles';
import HorizontalSelector from '../../genericComponents/HorizontalSelector'
import Text from '../../genericComponents/Text'
import {useTranslation} from 'react-i18next'; 

export default function AdvanceFilter({advancedFilters,setAdvancedFilters,speakerFilteredList}){
  const { t } = useTranslation();

  const formList = [
    {value:'all',text:t('all')},
    {value:'0',text:t('circle')},
    {value:'1',text:t('square')},
  ];
  const wooferInchList= [
    {value:'all',text:t('all')},
    {value:'0',text:'4”'},
    {value:'1',text:'5”'},
    {value:'2',text:'5.25”'},
    {value:'3',text:'6.5”'},
    {value:'4',text:'8”'},
  ];
  const viasList = [
    {value:'all',text:t('all')},
    {value:'0',text:t('one')},
    {value:'1',text:t('two')},
  ];

  const allYesNoOptions = [
    {value:'all',text:t('all')},
    {value:'1',text:t('yes')},
    {value:'0',text:t('no')},
  ];

  return (
    <Container>
      
      <Text titleSize={1} titleLevel={3}>{t('shape')}</Text>
      <HorizontalSelector
        options={formList}
        cuantity={[
          null,
          speakerFilteredList?.filter(f=>f.shape==="0").length,
          speakerFilteredList?.filter(f=>f.shape==="1").length
        ]}
        selected={advancedFilters?.form}
        onChange={(o)=>setAdvancedFilters('form',o.value)}
      />
      <Text titleSize={1} titleLevel={3}>{t('woofer_inches')}</Text>
      <HorizontalSelector
        fontSize='0.85em'
        options={wooferInchList}
        cuantity={[
          null,
          speakerFilteredList?.filter(f=>f.inches==="0").length,
          speakerFilteredList?.filter(f=>f.inches==="1").length,
          speakerFilteredList?.filter(f=>f.inches==="2").length,
          speakerFilteredList?.filter(f=>f.inches==="3").length,
          speakerFilteredList?.filter(f=>f.inches==="4").length
        ]}
        selected={advancedFilters?.wooferInch}
        onChange={(o)=>setAdvancedFilters('wooferInch',o.value)}
      />
      <Text titleSize={1} titleLevel={3}>{t('number_of_ways')}</Text>
      <HorizontalSelector
        options={viasList}
        cuantity={[
          null,
          speakerFilteredList?.filter(f=>f.vias==="0").length,
          speakerFilteredList?.filter(f=>f.vias==="1").length
        ]}
        selected={advancedFilters?.vias}
        onChange={(o)=>setAdvancedFilters('vias',o.value)}
      />  
      <Text titleSize={1} titleLevel={3}>{t('rear_speaker_cabinet')}</Text>
      <HorizontalSelector
        options={allYesNoOptions}
        cuantity={[
          null,
          speakerFilteredList?.filter(f=>f.enclosure==="1").length,
          speakerFilteredList?.filter(f=>f.enclosure==="0").length
        ]}
        selected={advancedFilters?.enclosure}
        onChange={(o)=>setAdvancedFilters('enclosure',o.value)}
      />
      <Text titleSize={1} titleLevel={3}>{t('en54')}</Text>
      <HorizontalSelector
        options={allYesNoOptions}
        cuantity={[
          null,
          speakerFilteredList?.filter(f=>f.EN54==="1").length,
          speakerFilteredList?.filter(f=>f.EN54==="0").length
        ]}
        selected={advancedFilters?.EN54}
        onChange={(o)=>setAdvancedFilters('EN54',o.value)}
      />
      <Text titleSize={1} titleLevel={3}>{t('ip_protection')}</Text>
      <HorizontalSelector
        options={allYesNoOptions}
        cuantity={[
          null,
          speakerFilteredList?.filter(f=>f.IPrange==="1").length,
          speakerFilteredList?.filter(f=>f.IPrange==="0").length
        ]}
        selected={advancedFilters?.ipRange}
        onChange={(o)=>setAdvancedFilters('ipRange',o.value)}
      />
      <Text titleSize={1} titleLevel={3}>{t('auto_amplified')}</Text>
      <HorizontalSelector
        options={allYesNoOptions}
        cuantity={[
          null,
          speakerFilteredList?.filter(f=>f.autoAmplified==="1").length,
          speakerFilteredList?.filter(f=>f.autoAmplified==="0").length
        ]}
        selected={advancedFilters?.autoAmplified}
        onChange={(o)=>setAdvancedFilters('autoAmplified',o.value)}
      />    
    </Container>
  )
}

const Container = styled.div`
  background-color: ${THEME.colors.ligtGrey};
  margin: 0 -8px;
  padding: 8px;
`;